import React from 'react';
import classNames from 'classnames';

import css from './IconEye.module.css';

/**
 * Alert icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} SVG icon
 */
const IconEye = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      stroke="currentColor"
      fill="currentColor"
      viewBox="0 0 512 512"
      height="30"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 0 0-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 0 0 0-17.47C428.89 172.28 347.8 112 255.66 112z"
      ></path>
      <circle
        cx="256"
        cy="256"
        r="80"
        fill="none"
        stroke-miterlimit="10"
        stroke-width="32"
      ></circle>
    </svg>
  );
};

export default IconEye;
